import { YMM_QUERY_PARAMS } from './ymmQueryString';

/** Class on `<html>` while a `?year&make&model` vehicle is being applied. */
export const YMM_QS_LOADING_CLASS = 'ymm-qs-loading';

/** Longest the page may stay blank if the vehicle lookup never settles. */
export const YMM_QUERY_STRING_HIDE_TIMEOUT_MS = 5000;

/**
 * Blanks the page while the vehicle is applied. Pure CSS so it applies before React loads. Everything is
 * `visibility: hidden !important` (still laid out, so nothing shifts when it lifts); a plain
 * `body{visibility:hidden}` is not enough because descendants that set `visibility: visible` stay focusable,
 * and tabbing to them scrolls the page. Hidden elements also take no clicks. The scroll lock is `!important`
 * because NavHeader writes an inline `overflow` on `<html>`, which would otherwise win.
 */
export const YMM_QUERY_STRING_HIDE_CSS = `
html.${YMM_QS_LOADING_CLASS}{overflow:hidden!important;scrollbar-gutter:stable}
html.${YMM_QS_LOADING_CLASS} body,html.${YMM_QS_LOADING_CLASS} body *{visibility:hidden!important}
`.trim();

/**
 * Inline `<head>` script, run before first paint. When the URL carries `year`, `make` and `model` it blanks
 * the page; `useYmmQueryString` lifts it (`revealPage`) once the vehicle is applied, or the timeout does as
 * a failsafe. It runs client-side on every request, so it is safe for Akamai-cached HTML.
 */
export function buildYmmQueryStringGuardScript(timeoutMs = YMM_QUERY_STRING_HIDE_TIMEOUT_MS): string {
    return `(function(){try{var p=new URLSearchParams(window.location.search);if(!${JSON.stringify(
        YMM_QUERY_PARAMS,
    )}.every(function(n){return p.has(n)}))return;var h=document.documentElement;h.classList.add(${JSON.stringify(
        YMM_QS_LOADING_CLASS,
    )});h.setAttribute('aria-busy','true');window.setTimeout(function(){h.classList.remove(${JSON.stringify(
        YMM_QS_LOADING_CLASS,
    )});h.removeAttribute('aria-busy')},${timeoutMs});}catch(e){}})();`;
}

export const YMM_QUERY_STRING_GUARD_SCRIPT = buildYmmQueryStringGuardScript();

export function revealPage(): void {
    document.documentElement.classList.remove(YMM_QS_LOADING_CLASS);
    document.documentElement.removeAttribute('aria-busy');
}

export function reloadPage(): void {
    window.location.reload();
}
